import React, { FC } from 'react';
import { useIconColor } from '../../../hooks/useIconColor';

interface IconPencilProps {
  className?: string;
  color?: string;
}

const IconPencil: FC<IconPencilProps> = (props: IconPencilProps) => {
  const { className, color } = props;

  const { iconColor } = useIconColor();
  const fillColor = color || iconColor;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M7.47224 21.2535C7.96317 19.7807 8.79025 18.4424 9.888 17.3447L19.3615 7.87117L23.5802 12.0899L14.1068 21.5634C13.009 22.6612 11.6707 23.4883 10.198 23.9792L7.05806 25.0258C6.66718 25.1561 6.29531 24.7842 6.4256 24.3934L7.47224 21.2535Z"
        fill={fillColor}
      />
      <path
        d="M22.5256 4.70711C22.9161 4.31658 23.5492 4.31658 23.9398 4.70711L26.7443 7.51164C27.1348 7.90217 27.1348 8.53533 26.7443 8.92586L24.2874 11.3828L20.0686 7.16406L22.5256 4.70711Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default IconPencil;
